import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchMessages } from '../../redux/message/actions.js';
import ReactMarkdown from 'react-markdown';
import ToolBar from '../ToolBar/ToolBar.js';
import Character from '../Character/Character.js';
import Loading from '../Loading/Loading.js';
import styles from './MessageBlock.module.css';
import downArrowSvg from './down-arrow.svg'; 


function MessageBlock({ scrollTargetRef }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const messagesEndRef = useRef(null);
  const loading = useSelector((state) => state.shared.shared_loading);
  const chat = useSelector((state) => state.chat.chats.find((chat) => chat.chat_id === id));
  const user_id = useSelector((state) => state.user.user_id);
  const messages = useSelector((state) => state.message.messages);

  const [showScrollToBottom, setShowScrollToBottom] = useState(false); 
  const [userScrolledUp, setUserScrolledUp] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);

  const handleScroll = () => {
    if (!scrollTargetRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollTargetRef.current;
    const nearBottom = scrollHeight - scrollTop - clientHeight < 150;

    if (nearBottom) {
      setShowScrollToBottom(false);
      setUserScrolledUp(false);
    } else {
      setShowScrollToBottom(true);
      setUserScrolledUp(true);
    }
  };

  useEffect(() => {
    if (scrollTargetRef.current) {
      scrollTargetRef.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollTargetRef.current) {

        scrollTargetRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      setShowScrollToBottom(false); // Hide arrow icon after scrolling to bottom
      setUserScrolledUp(false);
      setButtonClicked(true);
    }
  };

  useEffect(() => {
    if ((!userScrolledUp || buttonClicked) && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      if (buttonClicked) setButtonClicked(false);
    }
  }, [messages]);


  useEffect(() => {
      if (chat && user_id) {
        dispatch(fetchMessages(user_id, chat.chat_id));
      }
    }, [id, navigate, chat, user_id, dispatch]);


  useEffect(() => {
    if (messages.length > 0) {
      setSelectedMessage(messages[messages.length - 1]);
    }
  }, [messages]);

  useEffect(() => {
    console.log("Loading state changed:", loading);
  }, [loading]);
  
  return (
    <div className={styles.layout}>

      <div className={styles.message}>

        {messages.map((message, index) => (
            <React.Fragment key={`${message.message_id}-${index}`}>
              {message.role === 'user' ? (
                <div className={styles.question}>
                  {message.content}
                </div>
              ) : (
                <div className={styles.answer}>
                  <Character />
                  {loading && message === messages[messages.length - 1] && <Loading />}
                  <div>
                    <ReactMarkdown>{message.content}</ReactMarkdown>
                  </div>
                </div>
              )}
            </React.Fragment>
        ))}

        {!loading && selectedMessage && (
          <ToolBar
          user_id={user_id}
          message_id={selectedMessage.message_id}
          chat_id={chat ? chat.chat_id : null}
          chatHistory={messages}
          navigate={navigate}
          message_content={selectedMessage.content}
          message_sources={selectedMessage.sources}
          />
        )}
        
      </div>        

      <div ref={messagesEndRef} />
      {showScrollToBottom && (
        <button 
          className={styles.scrollToBottom} 
          onClick={scrollToBottom}
        >
        <img 
          src={downArrowSvg} 
          alt="scroll-to-bottom" 
          className={styles.scrollToBottom}
        />
      </button>
      )}
    </div>
  );
}

export default MessageBlock;